import lodash from 'lodash'
import { imageSizeOptions } from '../user-settings/constants'

export const GET_PIN = 'app/PinDetails/GET_PIN'
export const GET_PIN_DONE = 'app/PinDetails/GET_PIN_DONE'
export const GET_PIN_ERROR = 'app/PinDetails/GET_PIN_ERROR'

export const CLEAR_PIN = 'app/PinDetails/CLEAR_PIN'

// GET_LAST_PIN_TITLES
export const GET_LAST_PIN_TITLES = 'app/PinDetails/GET_LAST_PIN_TITLES'
export const GET_LAST_PIN_TITLES_DONE =
  'app/PinDetails/GET_LAST_PIN_TITLES_DONE'
export const GET_LAST_PIN_TITLES_ERROR =
  'app/PinDetails/GET_LAST_PIN_TITLES_ERROR'

// GET_LAST_TASK_TITLES
export const GET_LAST_TASK_TITLES = 'app/PinDetails/GET_LAST_TASK_TITLES'
export const GET_LAST_TASK_TITLES_DONE =
  'app/PinDetails/GET_LAST_TASK_TITLES_DONE'
export const GET_LAST_TASK_TITLES_ERROR =
  'app/PinDetails/GET_LAST_TASK_TITLES_ERROR'

export const ADD_TITLES_SUGGESTION = 'app/PinDetails/ADD_TITLES_SUGGESTION'
// Update pin
export const UPDATE_PIN = 'app/PinDetails/UPDATE_PIN'
export const UPDATE_PIN_DONE = 'app/PinDetails/UPDATE_PIN_DONE'
export const UPDATE_PIN_ERROR = 'app/PinDetails/UPDATE_PIN_ERROR'
export const REMOVE_UPDATE_PIN_ERROR = 'app/PinDetails/REMOVE_UPDATE_PIN_ERROR'

// get tags suggestions
export const SUGGEST_TAGS = 'app/PinDetails/SUGGEST_TAGS'
export const SUGGEST_TAGS_DONE = 'app/PinDetails/SUGGEST_TAGS_DONE'
export const SUGGEST_TAGS_ERROR = 'app/PinDetails/SUGGEST_TAGS_ERROR'

// get task list
export const GET_TASK_LIST = 'app/PinDetails/GET_TASK_LIST'
export const GET_TASK_LIST_DONE = 'app/PinDetails/GET_TASK_LIST_DONE'
export const GET_TASK_LIST_ERROR = 'app/PinDetails/GET_TASK_LIST_ERROR'

// get post list
export const GET_POST_LIST = 'app/PinDetails/GET_POST_LIST'
export const GET_POST_LIST_DONE = 'app/PinDetails/GET_POST_LIST_DONE'
export const GET_POST_LIST_ERROR = 'app/PinDetails/GET_POST_LIST_ERROR'
export const SET_OPEN_POST_ID = 'app/PinDetails/SET_OPEN_POST_ID'
export const REMOVE_OPEN_LIST_POST_ID =
  'app/PinDetails/REMOVE_OPEN_LIST_POST_ID'

// get comments of post
export const GET_COMMENTS_OF_POST = 'app/PinDetails/GET_COMMENTS_OF_POST'
export const GET_COMMENTS_OF_POST_DONE =
  'app/PinDetails/GET_COMMENTS_OF_POST_DONE'
export const GET_COMMENTS_OF_POST_ERROR =
  'app/PinDetails/GET_COMMENTS_OF_POST_ERROR'

// clear comment list
export const CLEAR_COMMENTS = 'app/PinDetails/CLEAR_COMMENTS'

// create comment
export const CREATE_COMMENT = 'app/PinDetails/CREATE_COMMENT'
export const CREATE_COMMENT_DONE = 'app/PinDetails/CREATE_COMMENT_DONE'
export const CREATE_COMMENT_ERROR = 'app/PinDetails/CREATE_COMMENT_ERROR'

// update comment
export const UPDATE_COMMENT = 'app/PinDetails/UPDATE_COMMENT'
export const UPDATE_COMMENT_DONE = 'app/PinDetails/UPDATE_COMMENT_DONE'
export const UPDATE_COMMENT_ERROR = 'app/PinDetails/UPDATE_COMMENT_ERROR'

export const OPEN_FULL_SCREEN = 'app/PinDetails/OPEN_FULL_SCREEN'
export const CLOSE_FULL_SCREEN = 'app/PinDetails/CLOSE_FULL_SCREEN'

// update task
export const UPDATE_TASK = 'app/PinDetails/UPDATE_TASK'
export const UPDATE_TASK_ERROR = 'app/PinDetails/UPDATE_TASK_ERROR'
export const UPDATE_TASK_DONE = 'app/PinDetails/UPDATE_TASK_DONE'

// get project companies
export const GET_PROJECT_COMPANIES = 'app/PinDetails/GET_PROJECT_COMPANIES'
export const GET_PROJECT_COMPANIES_ERROR =
  'app/PinDetails/GET_PROJECT_COMPANIES_ERROR'
export const GET_PROJECT_COMPANIES_DONE =
  'app/PinDetails/GET_PROJECT_COMPANIES_DONE'
// get company assignees
export const GET_COMPANY_ASSIGNEES = 'app/PinDetails/GET_COMPANY_ASSIGNEES'
export const GET_COMPANY_ASSIGNEES_ERROR =
  'app/PinDetails/GET_COMPANY_ASSIGNEES_ERROR'
export const GET_COMPANY_ASSIGNEES_DONE =
  'app/PinDetails/GET_COMPANY_ASSIGNEES_DONE'
export const GET_COMPANY_ASSIGNEES_PROGRESS =
  'app/PinDetails/GET_COMPANY_ASSIGNEES_PROGRESS'

// get project dependency suggestions
export const GET_PROJECT_DEPENDENCY_SUGGESTIONS =
  'app/PinDetails/GET_PROJECT_DEPENDENCY_SUGGESTIONS'
export const GET_PROJECT_DEPENDENCY_SUGGESTIONS_DONE =
  'app/PinDetails/GET_PROJECT_DEPENDENCY_SUGGESTIONS_DONE'
export const GET_PROJECT_DEPENDENCY_SUGGESTIONS_ERROR =
  'app/PinDetails/GET_PROJECT_DEPENDENCY_SUGGESTIONS_ERROR'
// get current issue dependency suggestions
export const GET_ISSUE_DEPENDENCY_SUGGESTIONS =
  'app/PinDetails/GET_ISSUE_DEPENDENCY_SUGGESTIONS'
export const GET_ISSUE_DEPENDENCY_SUGGESTIONS_DONE =
  'app/PinDetails/GET_ISSUE_DEPENDENCY_SUGGESTIONS_DONE'
export const GET_ISSUE_DEPENDENCY_SUGGESTIONS_ERROR =
  'app/PinDetails/GET_ISSUE_DEPENDENCY_SUGGESTIONS_ERROR'

// create task
export const CREATE_TASK = 'app/PinDetails/CREATE_TASK'
export const CREATE_TASK_DONE = 'app/PinDetails/CREATE_TASK_DONE'
export const CREATE_TASK_ERROR = 'app/PinDetails/CREATE_TASK_ERROR'
export const CLEAR_TASK_ERRORS = 'app/PinDetails/CLEAR_TASK_ERRORS'

// get recent notes / descriptions
export const GET_RECENT_NOTES = 'app/PinDetails/GET_RECENT_NOTES'
export const GET_RECENT_NOTES_DONE = 'app/PinDetails/GET_RECENT_NOTES_DONE'
export const GET_RECENT_NOTES_ERROR = 'app/PinDetails/GET_RECENT_NOTES_ERROR'

// create post
export const CREATE_POST = 'app/PinDetails/CREATE_POST'
export const CREATE_POST_DONE = 'app/PinDetails/CREATE_POST_DONE'
export const CREATE_POST_ERROR = 'app/PinDetails/CREATE_POST_ERROR'
// update post
export const UPDATE_POST = 'app/PinDetails/UPDATE_POST'
export const UPDATE_POST_DONE = 'app/PinDetails/UPDATE_POST_DONE'
export const UPDATE_POST_ERROR = 'app/PinDetails/UPDATE_POST_ERROR'
export const CLEAR_POST_ERRORS = 'app/PinDetails/CLEAR_POST_ERRORS'

// get dataset
export const GET_DATASET = 'app/PinDetails/GET_DATASET'
export const GET_DATASET_DONE = 'app/PinDetails/GET_DATASET_DONE'
export const GET_DATASET_ERROR = 'app/PinDetails/GET_DATASET_ERROR'
export const GET_DATASET_RECORDS_PAGE =
  'app/PinDetails/GET_DATASET_RECORDS_PAGE'
export const GET_DATASET_RECORDS_PAGE_DONE =
  'app/PinDetails/GET_DATASET_RECORDS_PAGE_DONE'
export const GET_DATASET_RECORDS_PAGE_ERROR =
  'app/PinDetails/GET_DATASET_RECORDS_PAGE_ERROR'

export const GET_ALL_DATASETS = 'app/PinDetails/GET_ALL_DATASETS'
export const GET_ALL_DATASETS_DONE = 'app/PinDetails/GET_ALL_DATASETS_DONE'
export const GET_ALL_DATASETS_ERROR = 'app/PinDetails/GET_ALL_DATASETS_ERROR'

export const MOVE_PIN_POSITION = 'app/PinDetails/MOVE_PIN_POSITION'
export const STOP_MOVE_PIN_POSITION = 'app/PinDetails/STOP_MOVE_PIN_POSITION'

export const COPY_PIN = 'app/PinDetails/COPY_PIN'
export const STOP_COPY_PIN = 'app/PinDetails/STOP_COPY_PIN'

// get issue history
export const GET_ISSUE_HISTORY = 'app/PinDetails/GET_ISSUE_HISTORY'
export const GET_ISSUE_HISTORY_DONE = 'app/PinDetails/GET_ISSUE_HISTORY_DONE'
export const GET_ISSUE_HISTORY_ERROR = 'app/Pin/GET_ISSUE_HISTORY_ERROR'
export const GET_ISSUE_PROPERTY_HISTORY =
  'app/PinDetails/GET_ISSUE_PROPERTY_HISTORY'
export const GET_ISSUE_PROPERTY_HISTORY_DONE =
  'app/PinDetails/GET_ISSUE_PROPERTY_HISTORY_DONE'
export const GET_ISSUE_PROPERTY_HISTORY_ERROR =
  'app/PinDetails/GET_ISSUE_PROPERTY_HISTORY_ERROR'

// get task history
export const GET_POST_HISTORY = 'app/PinDetails/GET_POST_HISTORY'
export const GET_POST_HISTORY_DONE = 'app/PinDetails/GET_POST_HISTORY_DONE'
export const GET_POST_HISTORY_ERROR = 'app/Pin/GET_POST_HISTORY_ERROR'

// get task history
export const GET_ALL_HISTORIES = 'app/PinDetails/GET_ALL_HISTORIES'
export const GET_ALL_HISTORIES_DONE = 'app/PinDetails/GET_ALL_HISTORIES_DONE'
export const GET_ALL_HISTORIES_ERROR = 'app/Pin/GET_ALL_HISTORIES_ERROR'

// set media inactive
export const SET_MEDIA_INACTIVE = 'app/PinDetails/SET_MEDIA_INACTIVE'
export const SET_MEDIA_INACTIVE_DONE = 'app/PinDetails/SET_MEDIA_INACTIVE_DONE'
export const SET_MEDIA_INACTIVE_ERROR =
  'app/PinDetails/SET_MEDIA_INACTIVE_ERROR'
export const SET_MEDIA_ACTIVE = 'app/PinDetails/SET_MEDIA_ACTIVE'
export const SET_MEDIA_ACTIVE_DONE = 'app/PinDetails/SET_MEDIA_ACTIVE_DONE'
export const SET_MEDIA_ACTIVE_ERROR = 'app/PinDetails/SET_MEDIA_ACTIVE_ERROR'
export const SHOW_INACTIVE_MEDIA = 'app/PinDetails/SHOW_INACTIVE_MEDIA'

export const REVISION_IMPORT_UPDATE_LOCK = 'app/Pin/REVISION_IMPORT_UPDATE_LOCK'

export const SET_EXTRA_PIN_PAN_TO_TOP =
  'app/PinDetails/SET_EXTRA_PIN_PAN_TO_TOP'

export const GET_NR_OF_OPEN_TASKS = 'app/PinDetails/GET_NR_OF_OPEN_TASKS'
export const GET_NR_OF_OPEN_TASKS_DONE =
  'app/PinDetails/GET_NR_OF_OPEN_TASKS_DONE'
export const GET_NR_OF_OPEN_TASKS_ERROR =
  'app/PinDetails/GET_NR_OF_OPEN_TASKS_ERROR'

export const GET_PIN_TAGS = 'app/PinDetails/GET_PIN_TAGS'
export const GET_PIN_TAGS_DONE = 'app/PinDetails/GET_PIN_TAGS_DONE'
export const GET_PIN_TAGS_ERROR = 'app/PinDetails/GET_PIN_TAGS_ERROR'

// get pin fields
export const GET_PIN_FIELDS = 'app/PinDetails/GET_PIN_FIELDS'
export const GET_PIN_FIELDS_DONE = 'app/PinDetails/GET_PIN_FIELDS_DONE'
export const GET_PIN_FIELDS_ERROR = 'app/PinDetails/GET_PIN_FIELDS_ERROR'

export const GET_SEARCH_TAGS_SUGGESTIONS =
  'app/PinDetails/GET_SEARCH_TAGS_SUGGESTIONS'
export const GET_SEARCH_TAGS_SUGGESTIONS_DONE =
  'app/PinDetails/GET_SEARCH_TAGS_SUGGESTIONS_DONE'
export const GET_SEARCH_TAGS_SUGGESTIONS_ERROR =
  'app/PinDetails/GET_SEARCH_TAGS_SUGGESTIONS_ERROR'

export const GET_TAGS_SUGGESTIONS = 'app/PinDetails/GET_TAGS_SUGGESTIONS'
export const GET_TAGS_SUGGESTIONS_DONE =
  'app/PinDetails/GET_TAGS_SUGGESTIONS_DONE'
export const GET_TAGS_SUGGESTIONS_ERROR =
  'app/PinDetails/GET_TAGS_SUGGESTIONS_ERROR'

export const ADD_TAGS_SUGGESTIONS = 'app/PinDetails/ADD_TAGS_SUGGESTIONS'

// get user role
export const GET_USER_ROLE = 'app/PinDetails/GET_USER_ROLE'
export const GET_USER_ROLE_DONE = 'app/PinDetails/GET_USER_ROLE_DONE'
export const GET_USER_ROLE_ERROR = 'app/PinDetails/GET_USER_ROLE_ERROR'
export const OPEN_ALERT_PLAN_VIEWER = 'app/PinDetails/OPEN_ALERT_PLAN_VIEWER'

// pin status options
export const pinStatus = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  INACTIVE: 'Inactive'
}

// possible post/task list options
export const postListOptions = {
  sort: {
    created: 'created',
    createdBy: 'createdBy',
    lastModified: 'lastModified'
  },
  sortDirection: {
    ASC: 'ASC',
    DESC: 'DESC'
  },
  filter: {
    Media: 'Media',
    Tasks: 'Tasks',
    Visuals: 'Visuals',
    TextOnly: 'TextOnly',
    Audio: 'Audio',
    Documents: 'Documents',
    All: 'All'
  },
  stateFilter: {
    Open: 'Open',
    Closed: 'Closed',
    Inactive: 'Inactive',
    Draft: 'Draft'
  },
  creatorFilter: {
    All: 'All',
    ByMe: 'ByMe',
    ByOthers: 'ByOthers'
  }
}

// default task list options
export const defaultTaskListOptions = {
  stateFilter: undefined,
  creatorFilter: postListOptions.creatorFilter.All,
  from: undefined,
  to: undefined
}
export const defaultPostListOptions = {
  filter: postListOptions.filter.Media,
  showInactive: undefined,
  creatorFilter: postListOptions.creatorFilter.All,
  from: undefined,
  to: undefined
}

// post types
export const mediaTypes = {
  SKETCH: 'Sketch',
  TASK: 'Task',
  TEXT_ONLY: 'TextOnly',
  VISUALS: 'Visuals',
  AUDIO: 'Audio',
  DOCUMENTS: 'Documents'
}

// possible task status
export const taskStatus = {
  DRAFT: 'Draft',
  OPEN: 'Open',
  CLOSED: 'Closed',
  INACTIVE: 'Inactive',
  OVERDUE: 'Overdue',
  REJECTED: 'Rejected'
}

// units for alert and repeat
export const taskTimeUnits = {
  MINUTES: 5,
  HOURS: 4,
  DAYS: 3,
  WEEKS: 2,
  MONTHS: 1,
  YEARS: 0
}
export const taskAlertUnits = {
  MINUTES: 'Minutes',
  HOURS: 'Hours',
  DAYS: 'Days',
  WEEKS: 'Weeks',
  MONTHS: 'Months',
  YEARS: 'Years'
}

export const quantityOptions = lodash
  .range(1, 999)
  .map((number) => ({ value: number, label: number }))

// pin history property types
export const propertyTypes = {
  title: 'Title',
  state: 'State',
  category: 'Category',
  linkedRecord: 'LinkedRecords'
}

// possible pin history list options
export const pinHistoryListOptions = {
  sortDirection: {
    ASC: 'ASC',
    DESC: 'DESC'
  },
  createdByFilter: {
    All: 'All',
    CreatedByMe: 'CreatedByMe',
    CreatedByOther: 'CreatedByOther'
  }
}

export const uploadImageSizes = {
  [imageSizeOptions.SMALL]: {
    // full hd
    width: 1920,
    height: 1080
  },
  [imageSizeOptions.MEDIUM]: {
    // 4K
    width: 4096,
    height: 2160
  },
  [imageSizeOptions.LARGE]: {
    // 8K
    width: 7680,
    height: 4320
  }
}

export const soundErrorMessages = {
  CODEC_ERROR: 'No codec support for selected audio sources.'
}

export const actionMessages = {
  RemoveDependency: { id: 'pinTask_removeDependency' },
  ExtendDueDate: { id: 'pinTask_extendDueDate' },
  Close: { id: 'pinList_setStatusClosed' },
  Inactive: { id: 'pinList_setStatusInactive' },
  Edit: { id: 'edit' },
  MarkAsUndone: { id: 'pinTask_undone' },
  MarkAsDone: { id: 'pinTask_mark' },
  DelegateResponsibility: { id: 'pinTask_delegate' },
  Reject: { id: 'pinTask_rejectTask' },
  Publish: { id: 'pinTask_createTask' }
}

export const TASK_OPTIONS = ['Close', 'Reopen', 'Deactivate']

export const MEDIA_TYPE = {
  comment: 'comment'
}

export const CLOSED = 'CLOSED'
export const INACTIVE = 'INACTIVE'

export const PIN_STATE = {
  [CLOSED]: {
    action: { id: 'close' },
    pinStatus: { id: 'closed' }
  },
  [INACTIVE]: {
    action: { id: 'deactivate' },
    pinStatus: { id: 'inactive' }
  }
}
